// Render Prop
import React from 'react';
import {Row, Col, Form, FormControl, Button, InputGroup, Modal} from 'react-bootstrap';
import HashLoader from 'react-spinners/HashLoader';
import S3ImageUpload from './S3ImageUpload';
const uuid = require('uuid/v4');

class DetailView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            name: "",
            description: "",
            category: "",
            vendor: "",
            vendorLink: "",
            cost: 0,
            itemNumber: "",
            swItemNumber: "",
            nwItemNumber: "",
            id: "",
            createNew: true,
            imageUrl: "",
            isSubmitting: false,
            isDeleting: false,
            deleteItem: false
        };
    }

    componentDidMount(){
        this.setState({
            name: this.props.itemValues.name || "",
            description: this.props.itemValues.description || "",
            category: this.props.itemValues.category || "",
            vendor: this.props.itemValues.vendor || "",
            vendorLink: this.props.itemValues.vendorLink || "",
            cost: this.props.itemValues.cost || "",
            itemNumber: this.props.itemValues.itemNumber || "",
            swItemNumber: this.props.itemValues.swItemNumber || "",
            nwItemNumber: this.props.itemValues.nwItemNumber || "",
            id: this.props.itemValues.id || uuid(),
            createNew: this.props.itemValues.id ? false : true,
            imageUrl: this.props.itemValues.imageUrl,
            isSubmitting: false,
            isDeleting: false,
            deleteItem: false
        })
    }

    handleChange(event) {
        let name = event.target.name;
        this.setState({[name]: event.target.value});
      }

    doSubmit(event){

        this.setState({
            isSubmitting: true
        })

        event.preventDefault();

        function blankStringRemover(obj){

            let newObj = {};
            Object.keys(obj).forEach((key, ind)=>{
                if(obj[key]==="")
                    newObj[key] = null;
                else
                    newObj[key] = obj[key];
            })
            
            return newObj;
        }

        let itemValues = {
            name: this.state.name,
            description: this.state.description,
            category: this.state.category,
            vendor: this.state.vendor,
            vendorLink: this.state.vendorLink,
            cost: this.state.cost,
            itemNumber: this.state.itemNumber,
            swItemNumber: this.state.swItemNumber,
            nwItemNumber: this.state.nwItemNumber,
            id: this.state.id,
            createNew: this.state.createNew,
            deleteItem: this.state.deleteItem
        }

        itemValues = blankStringRemover(itemValues);

        this.props.onSubmit(itemValues);
    }

    doDelete(event){

        this.setState({
            isDeleting: true
        })

        event.preventDefault();

        let itemValues = {
            id: this.state.id,
            deleteItem: this.state.deleteItem
        }

        this.props.onDelete(itemValues);
    }

    render () {

        return(
            
            <Form onSubmit={this.doSubmit.bind(this)}>
                {this.props.allowEdits &&
                    <div>
                        <Button variant="outline-danger" disabled={this.state.isDeleting} onClick={()=>{this.setState({deleteItem: true})}} style={{float:"right"}}>
                            <HashLoader sizeUnit={"px"} size={15} loading={this.state.isDeleting} /> {this.state.isDeleting ? 'Deleting...' : 'Delete'}
                        </Button>
                        <Button variant="primary" type="submit" disabled={this.state.isSubmitting} style={{float:"right", marginRight:10}}>
                            <HashLoader sizeUnit={"px"} size={15} loading={this.state.isSubmitting}/> {this.state.isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                }

                <Modal show={this.state.deleteItem}>
                    <Modal.Header closeButton>
                    <Modal.Title>Are you sure?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>This item will be deleted. Continue?</Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={()=>{this.setState({deleteItem: false})}}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={this.doDelete.bind(this)}>
                        Delete
                    </Button>
                    </Modal.Footer>
                </Modal>

                { this.props.allowEdits ?
                    <h2>Library Item</h2>
                    :
                    <h2>{this.state.name}</h2>
                }

                <Row>
                    <Col style={{marginRight: 40}}>
                        { this.props.allowEdits && 
                            <Form.Group controlId="formName">
                                <Form.Label>Name</Form.Label>
                                    <div>
                                        <Form.Control name="name" onChange={this.handleChange.bind(this)} value={this.state.name} type="text" placeholder="Item Name" />
                                        <Form.Text className="text-muted">
                                            The name of this item
                                        </Form.Text>
                                    </div>        
                            </Form.Group>
                        }

                        <Form.Group controlId="formCategory">
                            <Form.Label>Category</Form.Label>
                            { this.props.allowEdits ?
                                <Form.Control name="category" onChange={this.handleChange.bind(this)} value={this.state.category} type="text" placeholder="Category" />
                                :
                                <div>{this.state.category}</div>
                            }
                        </Form.Group>
                        
                        <Form.Group controlId="formDescription">
                            <Form.Label>Description</Form.Label>
                            { this.props.allowEdits ?
                                <Form.Control name="description" onChange={this.handleChange.bind(this)} value={this.state.description} as="textarea" placeholder="Item Description" />
                                :
                                <div>{this.state.description}</div>
                            }
                        </Form.Group>

                        <Form.Group controlId="formVendor">
                            <Form.Label>Vendor</Form.Label>
                            { this.props.allowEdits ?
                                <div>
                                    <Form.Control name="vendor" onChange={this.handleChange.bind(this)} value={this.state.vendor} type="text" placeholder="Vendor" />
                                    <Form.Control name="vendorLink" onChange={this.handleChange.bind(this)} value={this.state.vendorLink} type="text" placeholder="Vendor URL" />
                                </div>
                                :
                                <div>{this.state.vendor}<br/>{this.state.vendorLink && <a href={this.state.vendorLink}>{this.state.vendorLink}</a>}</div>
                            }
                        </Form.Group>

                    </Col>

                    <Col>
                        <label htmlFor="cost">Cost</label>
                        {
                            this.props.allowEdits ?
                            <InputGroup className="mb-3">
                                <InputGroup.Prepend>
                                <InputGroup.Text>$</InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl name="cost" onChange={this.handleChange.bind(this)} value={this.state.cost} id="cost" placeholder="00.00" />
                            </InputGroup>
                            :
                            <div>${this.state.cost}</div>
                        }

                        { this.props.allowEdits ?
                            <Form.Group controlId="formItemNumber">
                                <Form.Label>Item Number</Form.Label>
                                <Form.Control name="itemNumber" onChange={this.handleChange.bind(this)} value={this.state.itemNumber} type="text" placeholder="Item Number" />
                                
                                <Form.Label>SW Item Number</Form.Label>
                                <Form.Control name="swItemNumber" onChange={this.handleChange.bind(this)} value={this.state.swItemNumber} type="text" placeholder="SW Item Number" />
                                    
                                <Form.Label>NW Item Number</Form.Label>
                                <Form.Control name="nwItemNumber" onChange={this.handleChange.bind(this)} value={this.state.nwItemNumber} type="text" placeholder="NW Item Number" />
                            </Form.Group>
                            :
                            <img src={this.state.imageUrl} style={{marginTop: 20, maxWidth: 400}}/>
                        }
                        
                    </Col>
                </Row>
                { this.props.allowEdits && 
                    <Row>
                        <Col>
                            <Form.Group>
                                <img src={this.state.imageUrl} style={{height:150}}/>
                                { this.props.allowEdits &&
                                <   S3ImageUpload productId={this.state.id} onSubmit={this.handleChange.bind(this)} />
                                }
                            </Form.Group>
                        </Col>
                    </Row>
                }
            </Form>
        )
    }
}

export default DetailView;


// WEBPACK FOOTER //
// ./src/detailView.js